import { Roles } from "@/models/user/roles";
import { PartialNetSuiteCustomer, PriceLevel } from "@/models/netsuite/netsuite";
import { SSOImpersonation } from "@/services/auth_service";

export type GlobalState = {
  isLoading: boolean;
  isLoggedIn: boolean;
  isMobile: boolean;
  isTablet: boolean;
  userRole: Roles | null;
  authToken: string | null;
  multiplier: PriceLevel | null;
  priceLevels: PriceLevel[];
  customers: PartialNetSuiteCustomer[];
  impersonation: SSOImpersonation | null;
};

export type GlobalContext = {
  state: GlobalState;
  dispatch: (action: GlobalActions, payload?: any) => any;
  commit: (mutation: GlobalMutations, payload: any) => any;
};

export enum GlobalMutations {
  SetLoading = "setLoading",
  SetLoggedIn = "setLoggedIn",
  SetMobile = "setMobile",
  SetTablet = "setTablet",
  SetRole = "setRole",
  SetMultiplier = "setMultiplier",
  SetPriceLevels = "setPriceLevels",
  SetCustomers = "setCustomers",
  SetAuthToken = "setAuthToken",
  SetImpersonation = "setImpersonation"
}

export enum GlobalActions {
  AddLoading = "addLoading",
  AddLoggedIn = "addLoggedIn",
  AddMobile = "addMobile",
  AddTablet = "addTablet",
  AddRole = "addRole",
  AddMultiplier = "addMultiplier",
  AddPriceLevels = "addPriceLevels",
  AddCustomers = "addCustomers",
  AddAuthToken = "addAuthToken",
  AddImpersonation = "addImpersonation"
}

export enum GlobalGetters {
  GetLoading = "getLoading",
  GetLoggedIn = "getLoggedIn",
  GetMobile = "getMobile",
  GetTablet = "getTablet",
  GetRole = "getRole",
  GetMultiplier = "getMultiplier",
  GetPriceLevels = "getPriceLevels",
  GetCustomers = "getCustomers",
  GetAuthToken = "getAuthToken",
  GetImpersonation = "getImpersonation"
}
